<mat-form-field
  appearance="outline"
  [hideRequiredMarker]="true"
  [ngClass]="loading ? 'nsc-address-auto-complete' : ''"
  [formGroup]="group"
  class="nsc-address-auto-complete"
  subscriptSizing="dynamic"
  [attr.data-label]="placeholder"
>
  <mat-label>{{ placeholder }}</mat-label>
  <input
    id="{{ idx }}"
    #itemFilterInput
    matInput
    autocomplete="off"
    maxlength="{{ maxlength }}"
    formControlName="{{ controlName }}"
    type="search"
    (blur)="onBlur()"
    (focus)="onFocus()">
    @if (show.autocomplete) {
      <mat-card
        #optionList>
        @for (option of values.autocomplete; track option; let i = $index) {
          <mat-option
            [disabled]="option.disabled"
            [ngClass]="optionClass(i)"
            [value]="option.text"
            (click)="!option.disabled && selectOption(option)"
            (mouseenter)="optionHoverHandler($event, i)">
            {{ option.text }}
          </mat-option>
        }
      </mat-card>
    }
    <mat-hint aria-live="off">{{ content.hint }} @if (required) {
      <span class="mat_hit_hidden" >required</span>
    }</mat-hint>
    @if (group.controls[controlName].invalid) {
      <mat-error>Error: {{ validationMessage.get(group.controls[controlName], placeholder) }}</mat-error>
    }
  </mat-form-field>

